import { CssBaseline, Typography, Stack, Card as MuiCard, styled, Divider, Box } from '@mui/material';
import Logo from '../assets/logo.png'; // Assuming you have the logo image

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  marginTop: "0px",
  [theme.breakpoints.up('sm')]: {
    maxWidth: '450px',
  },
  boxShadow: 'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
  padding: 20,
  marginTop: '0',
  minHeight: '100vh', // Ensure full viewport height
  justifyContent: 'center', // Center vertically
  alignItems: 'center', // Center horizontally
  backgroundColor: 'hsl(210, 100%, 97%)',
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
      'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
  },
}));

function Finish() {
  return (
    <>
      <SignInContainer>
        <CssBaseline enableColorScheme />
        <Box sx={{ display: 'flex', justifyContent: 'center',alignContent:'center', mb: 4 }}>
          <img src="assets/BenowLogo2.jpg" alt="Logo" style={{ width: '100px' }} /> {/* Centered Logo */}
        </Box>
        <Card>
          <Typography variant='h5' align='center' fontWeight="bold">
            Thank you for your response!
          </Typography>
          <Typography variant='h6' align='center'>
            You may now close the tab.
          </Typography>
        </Card>
      </SignInContainer>
    </>
  );
}

export default Finish;
